module.exports = __webpack_public_path__ + "img/a11y-save-brush-1_en.e3bbaf0.jpg";